import { Text } from '@shared/components';

import {
  ContentSelectorByContentType,
  type ContentSelectorByContentTypeProps,
} from '../content-selector-by-content-type';
import { ContentTypeSection } from '../content-type-section';
import { type ContentTypeSectionProps } from '../content-type-section/content-type-section';
import { ItemSetTypeSelection, type ItemSetTypeSelectionProps } from '../item-set-type-selection';

interface QConfigItemSetQuestionConditionsFormFieldsProps {
  hideContentSelector?: boolean;
  slotProps: {
    itemSetTypeSelection?: ItemSetTypeSelectionProps;
    contentTypeSection?: ContentTypeSectionProps;
    contentSelectorByContentType: Omit<
      Extract<ContentSelectorByContentTypeProps, { questionType: 'item-set' }>,
      'questionType'
    >;
  };
}

export default function QConfigItemSetQuestionConditionsFormFields(
  props: Readonly<QConfigItemSetQuestionConditionsFormFieldsProps>,
) {
  const {
    hideContentSelector: shouldHideContentSelector,
    slotProps: {
      itemSetTypeSelection: itemSetTypeSelectionProps = {},
      contentTypeSection: contentTypeSectionProps = {},
      contentSelectorByContentType: contentSelectorByContentTypeProps,
    },
  } = props;

  return (
    <>
      <Text variant='body1Semibold'>1.เลือกประเภท Item Set</Text>
      <ItemSetTypeSelection {...itemSetTypeSelectionProps} />
      <Text variant='body1Semibold'>2. เลือกประเภทเนื้อหาที่ต้องการเพิ่ม</Text>
      <ContentTypeSection {...contentTypeSectionProps} />
      {!shouldHideContentSelector ? (
        <ContentSelectorByContentType
          questionType='item-set'
          {...contentSelectorByContentTypeProps}
        />
      ) : null}
    </>
  );
}
